import { defineMessage } from 'services/localization';

export const messages = {
    bankName: defineMessage('bank_name_1'),
    bankAccountName: defineMessage('account_name'),
    balance: defineMessage('balance'),
    accountNumber: defineMessage('account_number'),
    sortCode: defineMessage('sort_code'),
};
